module.exports = __webpack_public_path__ + "img/vip-free@2x.2ac65cc3.png";